
export class ConfigTableColumnVariable {
    id?: number;
  configVariableName?: string;
  configTableColumnName?: string;
  configVariableId?: number;
  configTableColumnId?: number;
  configFunctionsCalledInTableId?: number;
}
